'use strict';

var React = require('react');

var SvgBookIcon = function SvgBookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 6a.75.75 0 0 0 0 1.5h2.5a.75.75 0 1 0 0-1.5h-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.75 3a1.75 1.75 0 0 0-1.75 1.75v10a2.25 2.25 0 0 0 2.25 2.25h9a.75.75 0 0 0 0-1.5h-.25v-1.668c.591-.281 1-.884 1-1.582v-7.5a1.75 1.75 0 0 0-1.75-1.75h-8.5Zm1.25 1.5h-1.25a.25.25 0 0 0-.25.25v7.878c.235-.083.487-.128.75-.128h.75v-8Zm1.5 8v-8h5.75a.25.25 0 0 1 .25.25v7.5a.25.25 0 0 1-.25.25h-5.75Zm-2.25 3a.75.75 0 0 1 0-1.5h7.25v1.5h-7.25Z"
  }));
};
SvgBookIcon.displayName = "BookIcon";

exports.SvgBookIcon = SvgBookIcon;
